<div class="stack-statistics">
  <div class="stack-statistics-container">
    <div class="stack-statistics-title">
      {{ 'course.statistics.stackStatistic' | translate }}
    </div>
    <div class="stack-statistics-table">
      <div class="table">
        <div class="tab-header list">
          <div class="header-item">{{ 'course.table.name' | translate }}</div>
          <div class="header-item">
            {{ 'course.statistics.played' | translate }}
          </div>
        </div>
        @for (stat of stats; track stat.stack.id; let i = $index) {
        <div
          class="list table-border"
          (click)="onStackClick(stat)"
          data-cy="stackStatItem"
        >
          <div class="cell-item" data-cy="stackName">
            {{ stat?.stack.name }}
          </div>
          <div class="cell-item" data-cy="stackPlayed">
            {{ stat?.total_answers }}
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
